<template>
  <div>      
    <v-img src="../assets/img/home-icon.png" @click="goHome()" class="cursorhand" contain aspect-ratio="2.5"> </v-img>
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
          <v-img src="../assets/img/button-left-indicators.png" @click="showIndicator()" width="45px" class="mt-6 cursorhand" v-bind="attrs"
          v-on="on"> </v-img>
      </template>
      <span>Choose indicator</span>
    </v-tooltip>
    <!--v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-img src="../assets/img/button-left-regions.png" @click="showCountry()" width="45px" v-bind="attrs"
          v-on="on"> </v-img>
      </template>
      <span>Choose country</span>
    </v-tooltip-->
    <v-tooltip v-if="showSwitchMap" right>
      <template v-slot:activator="{ on, attrs }">
        <v-img src="../assets/img/button-left-TL.png" @click="showLevel()" width="45px" v-bind="attrs" class="cursorhand"
          v-on="on"> </v-img>
      </template>
      <span>Select Territorial Level</span>
    </v-tooltip>
    <v-tooltip v-if="showSwitchMap" right>
      <template v-slot:activator="{ on, attrs }">
        <v-img src="../assets/img/button-left-map-charts.png" @click="switchMapChart()" width="45px" class="mt-4 cursorhand" v-bind="attrs"
          v-on="on"> </v-img>
      </template>
      <span>Switch Map-Chart</span>
    </v-tooltip>

    <v-tooltip v-if="showControls" right>
      <template v-slot:activator="{ on, attrs }">
        <v-img src="../assets/img/button-left-plus.png" @click="mapZoomIn()" width="45px" class="mt-4 cursorhand" v-bind="attrs"
          v-on="on" > </v-img>
      </template>
      <span>Zoom in</span>
    </v-tooltip>
    <v-tooltip v-if="showControls" right>
      <template v-slot:activator="{ on, attrs }">
        <v-img src="../assets/img/button-left-minus.png" @click="mapZoomOut()" width="45px" class="cursorhand" v-bind="attrs"
          v-on="on" > </v-img>
      </template>
      <span>Zoom out</span>
    </v-tooltip>
    <v-tooltip v-if="showSwitchOECD"  right>
      <template v-slot:activator="{ on, attrs }">
        <v-img  src="../assets/img/button-left-worls-oecd.png" class="mt-4 cursorhand" @click="switchOECD()" v-bind="attrs"
          v-on="on" width="45px"> </v-img>
      </template>
      <span>Switch OECD - World map</span>
    </v-tooltip>

    <IndicatorSelector @changeIndicator="chgIndicator" :show="showInd"/>
    <LevelSelector @changeLevel="chgLevel" @goHome="resetCountry" :show="showLev"/>
    <!-- {{$store.getters.TU}} -- {{$store.getters.countryID}} -->
  </div>
</template>

<script>
import 'material-design-icons-iconfont/dist/material-design-icons.css' 
import IndicatorSelector from '@/components/IndicatorSelector.vue'
import LevelSelector from '@/components/LevelSelector.vue'

  export default {
    icons: {
      iconfont: 'mdi', // default - only for display purposes
    },
    name: 'FilterComponent',
    components: {IndicatorSelector, LevelSelector},
    // components: {IndicatorSelector, LevelSelector, CountrySelector, UnitSelector},
    props: {chgRegCity: Boolean, rstCountry: Boolean, currentYear: Number, show: Boolean,},
    watch: {
      '$route' () {
        console.log(this.$route.params)
        if ((this.$route.name === 'Home' || this.$route.name === 'OECDRegions')) {
          this.showSwitchOECD = true
        } else {
          this.showSwitchOECD = false
        }
        if (this.$route.params.indicod ==='REGION_TYP-RUR_URB_TYP-' || this.$route.params.indicod === 'REGION_TYP-MET_NOMET_TYP-') {
          this.showSwitchMap = false
        } else {
          this.showSwitchMap = true
        }
        this.$forceUpdate()
/*         if (this.$route.name === 'Home') {
          this.showControls = true
        } else {
          this.showControls = false
        } */
      },
/*       currentYear: function (y) {
        console.log(y)
      }, */
    },   
    methods: {
      filterChanged: function () {
        console.log('filter changed! NO!')
      },
      chgIndicator: function () {        
        this.filterChanged()
      },      
      chgCountry: function () {
        this.countryChg = !this.countryChg
        this.filterChanged()
      },
      chgUnit: function () {
        this.unitChg = !this.unitChg
      },
      chgLevel: function () {
        this.levelChg = !this.levelChg
        this.filterChanged()
      },
      resetCountry: function () {
        this.goingHome = !this.goingHome
        this.countryChg = !this.countryChg
        this.filterChanged()
      },      
      
      goHome: function () {
        this.$store.dispatch('restoreDefaultValue')
        this.$emit('goHome', {"c": this.$store.getters.country} )
        let params = {}
        params.tl = 'x'
        params.tu = 'x'
        params.c = 'x'
        params.indicod = 'x'
        params.year = 'x'
        this.$router.replace({ name: 'Home', params: params })
      },
      showIndicator: function () {
        this.showInd = !this.showInd 
      },
      showLevel: function () {
        this.showLev = !this.showLev 
      },
      showCountry: function () {
        this.showCount = !this.showCount 
      },
      showUnit: function () {
        this.showUn = !this.showUn
      },

      switchMapChart: function () {
        // Home <-> SubAreaChart
        // SubArea <--> SubAreaChart if c != '' 'x'
        // SubArea <--> SubAreaChart if c != '' 'x'
        // MetroRegional <--> MetroRegional tu != 'x
        let name = this.$route.name
        let params = this.$route.params
        let query = this.$route.query
        //console.log(name)
        //console.log(params)
        if (name === 'MetroRegional') {
          name = 'MetroRegionalChart'
        } else if (name === 'MetroRegionalChart') {
          name = 'MetroRegional'
        } else if (name === 'Home' || name === 'OECDRegions') {
          name = 'SubAreaChart'
        } else if (name === 'SubArea') {
          name = 'SubAreaChart'
        } else if (name === 'SubAreaChart') {
          if (params.c !== 'x') {
            name = 'SubArea'
          } else {
            if (this.$store.getters.zoom === 'OECD'  ) {name = 'OECDRegions'}
            else {name = 'Home'}
          }
        } 
        console.log("Router replace Home")
        //console.log(params)
        this.$router.replace({  name: name, params: params, query: query })
        },
        switchOECD: function () {
          if (this.$store.getters.TU === '' && this.$store.getters.countryID === '') {
          let name = this.$route.name
          let zoom = ''
          if (name === 'OECDRegions') {
            zoom = 'w'
            name = 'Home'
          } else {
            zoom = 'OECD'
            name = 'OECDRegions' 
          }
          this.$store.dispatch('setZoom', zoom)
          let parameters = this.$route.params
          let query = this.$route.query
          parameters.id = zoom
          this.$router.replace({  name: name, params: parameters, query: query })
          }
        },
        mapZoomIn: function () {
          this.$root.$emit('zoom_in')
        },
        mapZoomOut: function () {
          this.$root.$emit('zoom_out')
        }        

    },
    mounted () {
      this.$root.$on('filter_changed', () => {
          this.filterChanged()
      })
    },
    data: () => ({
      urlToCall: '',
      levelChg: false,
      goingHome: false,
      countryChg: false,
      unitChg: false,
      overlay: false,
      showInd: false,
      showLev: false,
      showCount: false,
      showUn: false,
      showControls: true,
      showSwitchOECD: true,
      showSwitchMap: true,
      tl: '',
      TU: '',
    })

  }
</script>
